import './experiences/styles/style.scss';

import InitCommand from './experiences/commands/InitCommand';
import Experience from './experiences/Experience';

InitCommand.Begin();
Experience.Init();
